"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IReelSpriteSymbol = void 0;
class IReelSpriteSymbol extends PIXI.Container {
}
exports.IReelSpriteSymbol = IReelSpriteSymbol;
//# sourceMappingURL=IReelSpriteSymbol.js.map